import React, { createContext, useState } from "react";

const TOKEN_KEY = "auth-token";
const META_KEY = "auth-meta";

export const AuthContext = createContext(null);

export const withAuth = (WrappedComponent) => {
  const Wrapper = (props) => {
    // Load localStorage data
    let localToken = null;
    let localMeta = {};

    try {
      localToken = localStorage.getItem(TOKEN_KEY);
      localMeta = JSON.parse(localStorage.getItem(META_KEY) || "{}");
    } catch (error) {
      localToken = null;
      localMeta = {};

      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(META_KEY);
    }

    // create state managers
    const [token, setToken] = useState(localToken);
    const [meta, setMeta] = useState(localMeta);

    const setAuth = (token, meta = {}) => {
      // Set context state
      setToken(token);
      setMeta(meta);

      // Set local state
      localStorage.setItem(TOKEN_KEY, token);
      localStorage.setItem(META_KEY, JSON.stringify(meta));
    };

    const clearAuth = () => {
      // Reset context state
      setToken(null);
      setMeta({});

      // Set secure store state
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(META_KEY);
    };

    const AuthContextValue = {
      token,
      meta,
      setAuth,
      clearAuth,
    };

    return (
      <AuthContext.Provider value={AuthContextValue}>
        <WrappedComponent {...props} />
      </AuthContext.Provider>
    );
  };

  return Wrapper;
};
